import { useState, useEffect } from 'react';

export function checkIsMobile() {
  return window.innerWidth < 800 || window.innerHeight <= 500;
}

export function checkIsMobilePortrait() {
  return (
    (window.innerWidth <= 800 || window.innerHeight <= 500) &&
    window.innerHeight > window.innerWidth
  );
}

export function checkIsNarrow() {
  return window.innerWidth < 1024;
}

export function checkIsHeroTooWide() {
  const aspectRatio = window.innerWidth / window.innerHeight;
  return aspectRatio >= 9 / 4;
}

export function checkIsIFrame() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function isPlaywrightTest(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  try {
    // Check for Playwright-specific indicators
    // Playwright sets navigator.webdriver to true
    // Also check user agent for HeadlessChrome which Playwright uses in headless mode
    const userAgent = navigator.userAgent || '';
    return (
      (navigator as any).webdriver === true ||
      userAgent.includes('HeadlessChrome') ||
      userAgent.includes('Playwright')
    );
  } catch {
    return false;
  }
}

export function useIsPlaywrightTest(): boolean {
  // Default to true (assume test) to prevent animation from rendering during SSR
  // Then check on client side after mount
  const [isTest, setIsTest] = useState(true);

  useEffect(() => {
    // Only check on client side after mount
    setIsTest(isPlaywrightTest());
  }, []);

  return isTest;
}

export function useWindowSize() {
  type Size = {
    width: number;
    height: number;
  };

  const [windowSize, setWindowSize] = useState<Size>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };
      window.addEventListener('resize', handleResize);
      handleResize();
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);
  return windowSize;
}
